import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/login',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '分类管理' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'Admin', meta: { name: '兑换积分管理' }, component: () => import('../views/manager/Admin') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '' }, component: () => import('../views/manager/Notice') },
      { path: 'business', name: 'Business', meta: { name: '加分状态管理' }, component: () => import('../views/manager/Business') },
      { path: 'user', name: 'User', meta: { name: '学生信息' }, component: () => import('../views/manager/User') },
      { path: 'businessPerson', name: 'BusinessPerson', meta: { name: '教师个人信息' }, component: () => import('../views/manager/BusinessPerson') },
      { path: 'category', name: 'Category', meta: { name:'商品管理' }, component: () => import('../views/manager/Category') },
      { path: 'course', name: 'Course', meta: { name: '用户管理' }, component: () => import('../views/manager/Course') },
      { path: 'banner', name: 'Banner', meta: { name: '客服地址管理' }, component: () => import('../views/manager/Banner') },
      { path: 'tw', name: 'Tw', meta: { name: '提问信息' }, component: () => import('../views/manager/tw') },

      { path: 'collect', name: 'Collect', meta: { name: '订单状态管理' }, component: () => import('../views/manager/Collect') },
      { path: 'comment', name: 'Comment', meta: { name: '课程评论信息' }, component: () => import('../views/manager/Comment') },
      { path: 'information', name: 'Information', meta: { name: '后台用户管理' }, component: () => import('../views/manager/Information') },
      { path: 'myInfo', name: 'MyInfo', meta: { name: '新建用户' }, component: () => import('../views/manager/MyInfo') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
